export default __webpack_public_path__ + "static/media/neb.2897c1c7.png";